export enum DialogName {
  Softticker = 'softticker',
  BestPlayerVoting = 'best-player-voting',
}
